"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ServerClass {
    constructor(id, name, dataTable) {
        this.id = id;
        this.name = name;
        this.dataTable = dataTable;
    }
}
exports.ServerClass = ServerClass;
//# sourceMappingURL=ServerClass.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@demostf/demo.js/build/Data/ServerClass.js
// module id = 26
// module chunks = 0